import { useState } from "react";
import { useNavigate } from "react-router-dom";

// internal hooks
import { useEscape } from "../hooks/useEscape";

// styles and images
import "./Components.css";
import Close from "../assets/close.svg";

// store
import { companyStore, messageAndErrorStore, userStore } from "../store/Store";

export default function UpdatePopup({
  setTrigger,
  url,
  method,
  title,
  errorMessage,
  successMessage,
  setState,
  body,
  invoice,
  dataKey,
  setStates,
  setStateFields
}) {
  // global state
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const setAuthStatus = userStore(
    (userDataStore) => userDataStore.setAuthStatus,
  );
  const setAuthError = messageAndErrorStore((data) => data.setAuthError);
  const toggleNewMessage = messageAndErrorStore((data) => data.toggleNewMessage);
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);

  // local
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  useEscape(setTrigger, [], [], pending);

  const handleClick = () => {
    setPending(true);
    var reqBody;
    if (body) {
      reqBody = body;
      reqBody.updated_by_id = currentUser.id;
    }
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method,
      headers,
      signal: controller.signal,
    };

    if (body) {
      requestOptions["body"] = JSON.stringify(body);
    }

    fetch(url, requestOptions)
      .then((res) => {
        if (res.status === 401) {
          navigate("/login");
          setAuthError(true);
          setTrigger(false);
          setAuthStatus(false);
          setPending(false);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          toggleNewMessage(errorMessage);
          setPending(false);
          return;
        } else {
          if (setState && dataKey) {
            setState(data[dataKey])
            setTrigger(false)
          } else if (setState) {
            setState(data);
            setTrigger(false);
          } else if (setStates) {
            setStates.forEach((s, idx) => {
              s(data[setStateFields[idx]])
            })
          }
          if (invoice) {
            setInvoiceCounts(data.invoice_counts);
          }
          setPending(false);
          setTrigger(false);
          toggleNewMessage(null, successMessage);
        }
      })
      .catch((err) => {
        console.log(err);
        toggleNewMessage(errorMessage);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner-add-company">
        {!pending && (
          <img src={Close} onClick={() => setTrigger(false)} alt="close" />
        )}
        {title && <p>{title}?</p>}
        {!pending && (
          <button className="delete-btn" onClick={handleClick}>
            Yes
          </button>
        )}
        {!pending && (
          <button className="propx-btn" onClick={() => setTrigger(false)}>
            No
          </button>
        )}
        {pending && (
          <button
            className="btn btn-secondary"
            style={{ margin: "20px 20px 20px 0" }}
            disabled
          >
            Submitting...
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        )}
      </div>
    </div>
  );
}
